import { Injectable } from '@angular/core';

import { SharedService, TranslationKey } from '../../shared';
import { IConfirmationDialogComponentData } from '../../shared/confirmation-dialog/confirmation-dialog.interfaces';

@Injectable({
    providedIn: 'root'
})
export class SeriesService {
    constructor(private sharedSvc: SharedService) {
    }

    async showDeleteConfirmation(): Promise<IConfirmationDialogComponentData> {
        return this.sharedSvc.showConfirmationDialog(
            this.sharedSvc.translate(TranslationKey.deleteEventSeriesDialogTitle),
            [
                this.sharedSvc.translate(TranslationKey.deleteEventSeriesDialogAreYouSure),
                this.sharedSvc.translate(TranslationKey.wontBeAbleToRestoreData)
            ]
        );
    }
}
